<template>
  <div class="oldest-container" ref="container">
    <div>
      <div class="content" :style="conHeight">
        <div class="contents">
          <el-row style="height:100%">
            <el-col :span="8" style="height:100%">
              <el-col :span="24" style="padding: 2vh">
                <div class="left-top">
                  <el-col :span="12" style="padding-right: 2vh">
                    <div class="left-top-left">
                      <div class="time-square">
                        <div class="time-square-middle">
                          <div class="time-square-middle-aa">
                            <div class="time-square-middle-circle">
                              <div class="time-square-middle-nexine">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="char">
                        服务总时长(时)
                      </div>

                      <div class="number" >
                        <count-to :startVal='lastPersonNum' separator=''  :endVal='serviceTime' :duration='1500'></count-to>
                      </div>

                    </div>



                  </el-col>

                  <el-col :span="12" style="padding-left: 2vh">
                    <div class="left-top-left">
                      <div class="time-square">
                        <div class="time-square-middle">
                          <div class="time-square-middle-aa">
                            <div class="time-square-middle-circle">
                              <div class="time-square-middle-nexine1">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="char">
                        总人数
                      </div>

                      <div class="number" >
                        <count-to :startVal='lastPersonNum' separator=''  :endVal='numberPople' :duration='1500'></count-to>
                      </div>

                    </div>




                  </el-col>
                </div>
              </el-col>

              <el-col :span="24" style="padding: 2vh">
                <div class="left-bottom">
                  <div class="left-bottom-top" >
                     男女志愿者比例
                  </div>

                  <div id="pie" >

                  </div>

                </div>

              </el-col>

            </el-col>
            <el-col :span="16" style="height:100%">
              <el-col :span="24" style="padding: 2vh">
                <div class="right-top">
                  <div class="right-top-top" >
                    兑换信息
                  </div>
                  <div class="right-top-bottom" >
                    <template>
                      <el-table
                        :data="tableData"
                        stripe
                        style="width: 100%" height="100%">
                        <el-table-column
                          prop="name"
                          label="姓名"
                          >
                        </el-table-column>
                        <el-table-column
                          prop="time"
                          label="时间"
                          >
                        </el-table-column>
                        <el-table-column
                          prop="message"
                          label="兑换信息"
                        >
                        </el-table-column>


                      </el-table>
                    </template>
                  </div>

                </div>
              </el-col>

              <el-col :span="24" style="padding: 2vh">
                <div class="right-bottom">
                   <div class="right-bottom-top" >
                      志愿者年龄分布
                   </div>

                  <div id="columnar" >

                  </div>



                </div>

              </el-col>
            </el-col>

          </el-row>
        </div>
      </div>
    </div>
    <div>

    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import {timefilters} from "@/common/times";
    import {getInsNameByDomainName} from "@/utils/auth";
export default {
  name: "Home",
  data() {
    return {
      serviceTime:1506,
      numberPople:2869,
      lastPersonNum:0,
      myCharts: '',
      conHeight: {
        height: ''
      },
      myPie: '',
      myPictograms: '',
      order: '',
      pie:'',
      columnar:'',
      tableData: [
        {
          name: '蔡付珍',
          time:'2020/7/23 09:04',
          message:'兑换餐饮服务一次',
        }, {
          name: '石秀华',
          time:'2020/7/22 10:34',
          message:'兑换餐饮服务一次',
        }, {
          name: '王启林',
          time:'2020/7/22 09:24',
          message:'兑换餐饮服务一次',
        }, {
          name: '李文芝',
          time:'2020/7/21 14:54',
          message:'兑换餐饮服务一次',
        }, {
          name: '陈万堂',
          time:'2020/7/21 11:25',
          message:'兑换餐饮服务一次',
        }, {
          name: '芮中秀',
          time:'2020/7/21 11:13',
          message:'兑换餐饮服务一次',
        }, {
          name: '胡道珍',
          time:'2020/7/21 10:25',
          message:'兑换餐饮服务一次',
        }, {
          name: '黄文贵',
          time:'2020/7/21 09:33',
          message:'兑换餐饮服务一次',
        }

      ],
    }
  },
  mounted() {
    this.$nextTick(() => { // 页面渲染完成后的回调
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    })
    this.init()
    var that = this
    window.addEventListener("resize", () => {
      that.pie.resize();
      that.columnar.resize();

    });
  },
  components: {countTo},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    },
  },
  // created(){
  //    this.init()
  // },
  methods: {
    init() {
      this.getColumnar();
      this.getPie();
      this.$store.commit('update', ['title',getInsNameByDomainName()+ '志愿者']);
      var that=this
      var table=document.querySelector('.el-table__body .el-table__row:nth-child(1)')
      console.log(table)
      var index=1
      setInterval(function () {
        if(index%2){
          table.style.display='table-row'
          that.changeTable()
        }else{
          table.style.display='none'
        }
        // that.changeTable()
        index++
      }, 2000);
    },
    changeTable() {
        //change、paly表格数据动态滚动
        this.tableData.push(this.tableData[0]);//把第一条数据插入数组最有一条
        this.tableData.shift();//删除数组中第一条数据
        this.tableData.push(this.tableData[0]);//把第一条数据插入数组最有一条
        this.tableData.shift();//删除数组中第一条数据
      },
    getTime(){
      return timefilters(new Date());
    },
    getColumnar(){
      this.columnar = this.$echarts.init(document.getElementById('columnar'))

      var option={
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ['男', '女'],
          align: 'right',
          top:25,
          textStyle: {
            color: "#fff"
          }
        },
        grid: [{
          // show: true,
          left: '10%',
          right: '12%',
          bottom: 50,
          top: '20%',
        }
        ],
        xAxis: [
          {type: 'category',
            data: ['10岁-20岁', '20岁-30岁', '30岁-40岁','40岁-50岁','50岁-60岁','60岁-70岁'],
            splitNumber: 6,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(0, 152, 215, 1)',
              },
            },
            axisLabel: {
              interval: 0,
              color:'#fff'
            }
          }],
        yAxis: [{
          type: "value",
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: "rgba(2, 100, 212, 1)"
            }
          },
          // axisTick: {
          //   lineStyle: {
          //     color: 'rgba(18, 114, 189, 1)',
          //   }
          // },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 152, 215, 1)',
            }
          },
          axisLabel:{
            color:'#fff'
          },

        }],
        series: [
          {
            name:"男",
            type: 'bar',
            barWidth: "20%",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: "#EE7E1B"
                },
                  {
                    offset: 1,
                    color: '#EEC91B'
                  }
                ]),
              }
            },
            data: [253, 768, 403, 54, 10, 2]},
          {
            name:"女",
            type: 'bar',
            barWidth: "20%",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: "#0065D7"
                },
                  {
                    offset: 1,
                    color: '#00FCFF'
                  }
                ]),
              }
            },
            data: [319, 618, 318, 46, 9, 1]
          }

        ]
      }



      this.columnar.setOption(option)
    },
    getPie(){
      this.pie = this.$echarts.init(document.getElementById('pie'))
      var data=[{value: 2784,name: '男'},{value: 1789,name: '女'}]
      var option = {

        color:['rgba(255, 166, 79, 1)','rgba(14, 229, 255, 1)'],
        tooltip: {
          trigger: 'item',
          position:'right',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          left: '40%',
          data: ['男','女'],
          textStyle: {
            color: "#fff",
            padding:[0,10,0,0],
            fontSize:18,
            lineHeight:30,
          },
        },
        series: [
          {
            name: '男女志愿者比例',
            type: 'pie',
            radius: ['50%', '70%'],
            // avoidLabelOverlap: true,
            label: {
              show: true,
              fontSize: 18,
              formatter: function(params) {
                var percent = 0;
                var total = 0;
                for (var i = 0; i < data.length; i++) {
                  total += data[i].value;
                }
                percent = ((params.value / total) * 100).toFixed(0);
                if(params.name !== '') {
                  return params.name + '\n' + '\n' + percent + '%';
                }else {
                  return '';
                }
              },
            },
            labelLine: {
              length2:80,
              length:30,
              show: true
            },
            data: data
          }

        ]
      };

      this.pie.setOption(option)
    }


  }
}


</script>

<style lang="scss" scoped>
.oldest-container {
  width: 100%;
  height: 100vh;
  margin-top: -75px;
  background-image: url(./img/background.jpg);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center top;
  min-width: 1320px;
  min-height: 736px;

  .content {
     height: 100%;
    margin: 0;
    padding: 0;
    // margin-top: 80px;
    padding: 0 2.6vw;
    padding-top: 90px;
  }

  .contents {
    min-width: 1220px;
    height: 100%;

    .left-top {
      //border: 1px solid red;
      height: 40.5vh;
      min-height: 315px;

      .left-top-left {
        //border: 1px solid rgba(4, 120, 228, 1);
        height: 36.5vh;
        background-size: 100% 100%;
        background-image: url(./img/left-top.png);
        background-repeat: no-repeat;
        padding-top: 40px;

        .time-square {
          //border: 1px solid red;
          width: 186px;
          height: 186px;
          margin: 0 auto;
          background-size: 100% 100%;
          background-image: url(./img/outer.png);
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          animation: turn 3.5s linear infinite;

          .time-square-middle {
            //border: 1px solid red;
            width: 150px;
            height: 150px;
            margin: 0 auto;
            background-size: 100% 100%;
            background-image: url(./img/circle.png);
            background-repeat: no-repeat;
            display: flex;
            align-items: center;

            .time-square-middle-aa {
              //border: 1px solid yellow;
              width: 125px;
              height: 125px;
              background-size: 50% 100%;
              background-image: url(./img/aaa.png);
              background-repeat: no-repeat;
              display: flex;
              align-items: center;
              margin: 0 auto;
              //animation: back 2.5s linear infinite;

              .time-square-middle-circle {
                //border: 1px solid green;
                width: 100px;
                height: 100px;
                margin: 0 auto;
                background-size: 100% 100%;
                background-image: url(./img/bb.png);
                background-repeat: no-repeat;
                display: flex;
                align-items: center;

                .time-square-middle-nexine {
                  //border: 1px solid yellow;
                  width: 60px;
                  height: 60px;
                  margin: 0 auto;
                  background-size: 100% 100%;
                  background-image: url(./img/nexine.png);
                  background-repeat: no-repeat;
                  animation: back 3.5s linear infinite;
                }

                .time-square-middle-nexine1{
                  width: 60px;
                  height: 60px;
                  margin: 0 auto;
                  background-size: 100% 100%;
                  background-image: url(./img/nexine1.png);
                  background-repeat: no-repeat;
                  animation: back 3.5s linear infinite;
                }
              }

            }


          }

          @keyframes back {
            0% {
              -webkit-transform: rotate(0deg);
            }
            25% {
              -webkit-transform: rotate(-90deg);
            }
            50% {
              -webkit-transform: rotate(-180deg);
            }
            75% {
              -webkit-transform: rotate(-270deg);
            }
            100% {
              -webkit-transform: rotate(-360deg);
            }
          }
          @keyframes turn {
            0% {
              -webkit-transform: rotate(0deg);
            }
            25% {
              -webkit-transform: rotate(90deg);
            }
            50% {
              -webkit-transform: rotate(180deg);
            }
            75% {
              -webkit-transform: rotate(270deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
            }
          }

        }

      }

      .char{
        font-size:18px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(253,247,242,1);
        text-align: center;
        margin-top: 30px;
      }

      .number{
        font-size:29px;
        font-family:Century Gothic;
        font-weight:bold;
        color:rgba(9,211,238,1);
        text-align: center;
        margin-top: 10px;
      }

      .left-top-right {
        //border: 1px solid rgba(4, 120, 228, 1);
        height: 36.5vh;
        background-size: 100% 100%;
        background-image: url(./img/left-top.png);
        background-repeat: no-repeat;
        padding-top: 40px;
      }


    }

    .left-bottom {
      opacity: 0.9;
      background-color: rgba(0, 39, 110, 1);
      border: 1px solid rgba(4, 120, 228, 1);
      height: 40.5vh;
      min-height: 315px;
      border-radius: 10px;
      position: relative;

      .left-bottom-top{
        //border: 1px solid green;
        width: 200px;
        height: 40px;
        margin-left: 20px;
        margin-top: 20px;
        background-size: 100% 100%;
        background-image: url(./img/left-bottom-top.png);
        background-repeat: no-repeat;
        font-size:22px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(12,246,255,1);
        line-height:40px;
        text-align: center;
      }

      #pie{
        //border: 1px solid red;
        width: 100%;
        height: 330px;

      }
    }

    .right-top {
      opacity: 0.9;
      background-color: rgba(0, 39, 110, 1);
      border: 1px solid rgba(4, 120, 228, 1);
      height: 40.5vh;
      min-height: 315px;
      border-radius: 10px;
      .right-top-top{
        //border: 1px solid green;
        width: 130px;
        height: 40px;
        margin-top: 15px;
        margin-left: 25px;
        background-size: 100% 100%;
        background-image: url(./img/right-top-top.png);
        background-repeat: no-repeat;
        font-size:22px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(12,246,255,1);
        line-height:40px;
        text-align: center;
      }

      .right-top-bottom{
        //border: 1px solid green;
        width: 94%;
        margin: 15px auto;
        height: 300px;


        /deep/ .el-table {
          background-color:transparent;
        }
        .el-table::before {
          height: 0px;
        }

        ::v-deep .el-table th,
        ::v-deep .el-table td {
          text-align: center !important;
        }


        /deep/ .el-table th {
          background-color:transparent;

        }
        /deep/ .el-table__row td{
          border: none;
        }
        /deep/ .el-table__header tr {
          background-image: linear-gradient(to right,rgba(3, 86, 211, 1),rgba(6, 176, 255, 1));
          //background-color: rgba(14, 115, 232, 1);
        }
        /deep/ .el-table__body .el-table__row{
          background-color: transparent;
          transition: all .3s;
        }
        /deep/ .el-table__body .el-table__row--striped{
          background-color: rgba(3, 82, 171, 1);
          //background-color: transparent;
        }
        /deep/ .el-table__body .el-table__row--striped td{
          background-color:transparent;
        }
        /deep/ .el-table th.is-leaf {
          border: 0;
        }
        /deep/ .el-table__header .cell {
          color: rgba(28, 252, 255, 1);
        }
        /deep/ .el-table td div {
          color: rgba(161, 212, 255, 1);
        }
        /deep/  .el-table__body{
          width: 100% !important;
        }
        /deep/ .el-table__header .gutter{
          display: none !important;
        }
        /deep/ .el-table tbody tr:hover>td { 
            background-color:transparent!important
        }
        /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {width: 17px;}
        /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 10px;
          display: none;
          background: #00FFFF;
        }
        /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 0;
          background: transparent;
        }


      }

    }

    .right-bottom {
      opacity: 0.9;
      border: 1px solid rgba(4, 120, 228, 1);
      height: 40.5vh;
      min-height: 315px;
      border-radius: 10px;
      background-color: rgba(0, 39, 110, 1);
      position: relative;
      .right-bottom-top{
        //border: 1px solid green;
        width: 200px;
        height: 40px;
        margin-top: 23px;
        margin-left: 24px;
        background-size: 100% 100%;
        background-image: url(./img/right-bottom-top.png);
        background-repeat: no-repeat;
        font-size:22px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(12,246,255,1);
        line-height:40px;
        text-align: center;

      }

      #columnar{
        //border: 1px solid green;
        width: 94%;
        margin: 0 auto;
        height: 320px;

      }



    }

  }


}

</style>
